/** Descarga un CSV (UTF-8 con BOM para que Excel respete acentos). */
export function downloadCsv(filename: string, rows: string[][]): void {
  const csv = rows
    .map((r) =>
      r
        .map((cell) => {
          const safe = (cell ?? '').replace(/"/g, '""');
          return /[",\n]/.test(safe) ? `"${safe}"` : safe;
        })
        .join(',')
    )
    .join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
